import { render, staticRenderFns } from "./_id_.vue?vue&type=template&id=f6736996&scoped=true&"
import script from "./_id_.vue?vue&type=script&lang=js&"
export * from "./_id_.vue?vue&type=script&lang=js&"
import style0 from "./_id_.vue?vue&type=style&index=0&id=f6736996&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6736996",
  null
  
)

export default component.exports